import { consumer } from "@lib/cable";
import {
  type BackgroundTask,
  type BackgroundTaskState,
  useBackgroundTasksStore,
} from "@lib/stores/backgroundTasksStore";
import { useEffect, useRef } from "react";

export function useBackgroundTasksChannel() {
  const subscriptionRef = useRef<ReturnType<typeof consumer.subscriptions.create>>(null);

  useEffect(() => {
    const upsert = useBackgroundTasksStore.getState().upsert;
    const prune = useBackgroundTasksStore.getState().prune;

    subscriptionRef.current = consumer.subscriptions.create(
      { channel: "BackgroundTaskChannel" },
      {
        received(data: Record<string, unknown>) {
          if (!data || typeof data.id !== "string") return;
          const task: BackgroundTask = {
            id: data.id,
            kind: (data.kind as string) ?? "",
            title: (data.title as string) ?? "",
            state: (data.state as BackgroundTaskState) ?? "running",
            subjectType: (data.subject_type as string | null) ?? null,
            subjectId: (data.subject_id as string | null) ?? null,
            parentTaskId: (data.parent_task_id as string | null) ?? null,
            errorMessage: (data.error_message as string | null) ?? null,
            result: (data.result as Record<string, unknown> | null) ?? null,
            startedAt: (data.started_at as string | null) ?? null,
            finishedAt: (data.finished_at as string | null) ?? null,
            updatedAt: (data.updated_at as string) ?? new Date().toISOString(),
          };
          upsert(task);
        },
      },
    );

    const pruneInterval = setInterval(prune, 30_000);

    return () => {
      subscriptionRef.current?.unsubscribe();
      subscriptionRef.current = null;
      clearInterval(pruneInterval);
    };
  }, []);
}
